import React, { useContext } from "react";
import { SimpleContext } from "../../../../../store/context/simple-context";
import "./index.scss";

const COLUMN_NAMES = ["TOOLS & SERVICES", "MONTHLY", "YEARLY", "LIFETIME"];

const TableHead = () => {
  const {
    translate: { t },
  } = useContext(SimpleContext);
  return (
    <ul className="GP-C-T-TH">
      {COLUMN_NAMES.map((name) => (
        <li key={name} className="GP-C-T-TH-colum">
          {t(name)}
        </li>
      ))}
    </ul>
  );
};

export default TableHead;
